// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 5228 ? "ProductsSlider" : chunkId) + ".js?id=" + {"4945":"fb73b5ae5545883d","5228":"5377f5f5b7d73866"}[chunkId] + "";
};